import styles from "./pull-to-refresh-indicator.module.css";
import { PULL_THRESHOLD } from "@coworker/apprestructured/src/shared/hooks/usePullToRefresh/pullToRefreshConstants";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ArrowPairSquarepathIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowPairSquarepathIconPath";
import { useTranslation } from "@coworker/locales";

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  isRefreshing: boolean;
  hasReachedThreshold: boolean;
}

export const PullToRefreshIndicator = ({
  pullDistance,
  isRefreshing,
  hasReachedThreshold,
}: PullToRefreshIndicatorProps) => {
  const { t } = useTranslation();
  if (pullDistance === 0 && !isRefreshing) return null;

  const progress = Math.min(pullDistance / PULL_THRESHOLD, 1);
  const rotation = progress * 360;

  return (
    <div
      className={styles["pull-to-refresh-indicator"]}
      style={{
        height: `${pullDistance}px`,
        transition: isRefreshing ? "height 0.3s ease" : "none",
      }}
    >
      <div
        className={
          isRefreshing
            ? styles["spinner-refreshing"]
            : styles["spinner-pulling"]
        }
        style={{
          opacity: isRefreshing ? 1 : progress,
          transform: isRefreshing
            ? undefined
            : `rotate(${rotation}deg) scale(${hasReachedThreshold ? 1.15 : 1})`,
          transition: hasReachedThreshold ? "transform 0.15s ease" : undefined,
        }}
      >
        <FixaSSRIcon paths={ArrowPairSquarepathIconPath} />
      </div>
      {isRefreshing && (
        <span className={styles["refreshing-text"]}>
          {t("refreshingString")}
        </span>
      )}
    </div>
  );
};
